import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../../services/authApi";
import { formatApiErrorDetail } from "../../lib/api";
import { useLocalization } from "../../hooks/useLocalization";

export default function ResetPasswordPage() {
  const { t } = useLocalization();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await authApi.resetPassword(token, newPassword);
      navigate("/staff/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="w-full max-w-sm" data-testid="reset-password-page">
      <h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-6">{t("auth.resetPassword")}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <label htmlFor="reset-password" className="sr-only">{t("auth.newPassword")}</label>
        <input
          id="reset-password"
          data-testid="reset-password-input"
          type="password"
          required
          minLength={8}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder={t("auth.newPassword")}
          className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
        />
        {error && <p className="text-sm text-red-500">{error}</p>}
        <button
          data-testid="reset-password-submit-button"
          type="submit"
          className="w-full py-3 rounded-full bg-blue-600 text-white font-semibold hover:bg-blue-700 active:scale-95 transition-all"
        >
          {t("auth.resetPassword")}
        </button>
      </form>
    </div>
  );
}
